<template>
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close" data-coreui-dismiss="modal" aria-label="Close" />
  </div>
</template>

<script>
export default {
  name: "ModalTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
  }
}
</script>
